module.exports = __webpack_public_path__ + "img/mastercard_logo.e2b10d26.svg";